import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {MessageModalGraphic} from './assets/message-modal-graphic';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function MessageEngagementModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<MessageModalGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>Message engagement</ModalHeader>
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            Nutshell automatically tracks when your messages are delivered, opened,
                            and clicked.
                        </ModalBody>
                    </SpacerGroup>
                    <BulletedList
                        bullets={[
                            <ModalBody key='1'>
                                <b>Messages delivered</b> shows the total number of messages that
                                were successfully delivered
                            </ModalBody>,
                            <ModalBody key='2'>
                                <b>Open rate</b> represents the percentage of delivered messages
                                that have been opened
                            </ModalBody>,
                            <ModalBody key='3'>
                                <b>Click rate</b> represents the percentage of delivered messages
                                that have been clicked
                            </ModalBody>,
                        ]}
                    />
                </div>
            }
        />
    );
}
